export default $client => ({
    login(attributes) {
        return $client.post('auth/login', {
            email: attributes.email,
            password: attributes.password,
        })
    },
});
